import CheckIcon from "@mui/icons-material/Check";
import { Button, Tab, Tabs } from "@mui/material";
import { Spin } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { PsLabel } from "../../components";
import PsModalWindow from "../../components/PsModalWindow";
import PsContext from "../../context";
import { useDialog } from "../../context/DialogContext";
import {
  _LIST_SCHOOL_STATISTICS,
  _UPDATE_SCHOOL,
} from "../../models/schoolsModel";
import { formToObject } from "../../utils";
import PsOffCanvasWindow from "../../components/PsOffCanvasWindow";
import SchoolHome from "./schoolHome";
import axios from "axios";
import SchoolLoginDetails from "./schoolLoginDetails";
import RecentUpdatedTables from "./recentUpdatedTables";
import TransactionList from "./transactionList";

const NewEditSchoolForm = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const { openDialog } = useDialog();

  const [value, setValue] = useState(0); // State for tab selection
  const [schoolStats, setSchoolStats] = useState([]);
  const [loginDetails, setLoginDetails] = useState([]);
  const [recentUpdateTables, setRecentUpdateTables] = useState([]);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    loadData();
    loadLoginDetails();
    loadRecentUpdatedTable();
  }, []);

  const loadData = () => {
    setLoader(true);

    const form = new FormData();
    form.append("sadb", props.dataSource.school_prefix);

    const apiUrl =
      "https://school.kalvisalai.in/api/v1/masteradmin/list-school-statistics";

    axios
      .post(apiUrl, form)
      .then((res) => {
        if (res.data.status === "1") {
          setSchoolStats(res.data.data);
        } else {
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const loadLoginDetails = () => {
    setLoader(true);

    const form = new FormData();
    form.append("sadb", props.dataSource.school_prefix);

    const apiUrl =
      "https://school.kalvisalai.in/api/v1/masteradmin/login-details";

    axios
      .post(apiUrl, form)
      .then((res) => {
        if (res.data.status === "1") {
          setLoginDetails(res.data.data);
        } else {
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const loadRecentUpdatedTable = () => {
    setLoader(true);

    const form = new FormData();
    form.append("sadb", props.dataSource.school_prefix);

    const apiUrl =
      "https://school.kalvisalai.in/api/v1/masteradmin/recent-updated-table";

    axios
      .post(apiUrl, form)
      .then((res) => {
        if (res.data.status === "1") {
          setRecentUpdateTables(res.data.data);
        } else {
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  return (
    <>
      <Spin spinning={loader}>
        <Tabs value={value} onChange={handleTabChange} aria-label="school tabs">
          <Tab label="Home" />
          <Tab label="Login Details" />
          <Tab label="Recent" />
          <Tab label="Transaction" />
        </Tabs>

        {value === 0 && (
          <SchoolHome dataSource={props.dataSource} schoolStats={schoolStats} />
        )}
        {value === 1 && (
          <SchoolLoginDetails
            dataSource={props.dataSource}
            loginDetails={loginDetails}
          />
        )}

        {value === 2 && (
          <RecentUpdatedTables
            dataSource={props.dataSource}
            recentUpdateTables={recentUpdateTables}
          />
        )}
        {value === 3 && <TransactionList dataSource={props.dataSource} />}
      </Spin>
    </>
  );
};

export default NewEditSchoolForm;
